export default __webpack_public_path__ + "static/media/25.70c5ef30.jpg";